export default __webpack_public_path__ + "static/media/weight.03428802.svg";